import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { ApiQueryParams } from 'types';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetNotesByReferenceProps = {
  referenceId: string;
  referenceType: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

export const getNotesByReference =
  ({
    referenceId,
    referenceType,
    params = {},
    signal,
  }: GetNotesByReferenceProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get(`/notes/reference`, {
        params: {
          referenceId,
          referenceType,
          ...params,
        },
        // signal,
      });
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
